/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Compax Frontend API-v2
 * API by Compax
 * OpenAPI spec version: 161.0.0-SNAPSHOT
 */

export type PermissionPermissionType =
  (typeof PermissionPermissionType)[keyof typeof PermissionPermissionType];

export const PermissionPermissionType = {
  TERMS_AND_CONDITIONS: "TERMS_AND_CONDITIONS",
  LETTER: "LETTER",
  EMAIL: "EMAIL",
  SMS: "SMS",
  PHONE: "PHONE",
  MARKETING: "MARKETING",
  NEWSLETTER: "NEWSLETTER",
  MAGIC_LINK: "MAGIC_LINK",
} as const;
